export default __webpack_public_path__ + "a518c6f34970bdbe3e78aafe6e075da9.svg";